
import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';

const LayoutAdminFooter = () => {
 return (
     <Box
       sx={{
         bgcolor: '#00305f',
         color: '#cbd5e1',
         py: 1, // matching vertical padding
         borderTop: '1px solid #1e293b', // same subtle top border
       }}
     >
       <Container maxWidth="lg">
         <Typography
           variant="body2"
           align="center"
           sx={{
             lineHeight: 3,
             fontSize: '0.8rem',
             fontFamily: "'Poppins', sans-serif",
           }}
         >
           © 2025 Easup. All rights reserved.
         </Typography>
       </Container>
     </Box>
   );
 };

export default LayoutAdminFooter;
